import API from '@sesame/web-api';

import { IWarranty } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';

const warrantyList: IWarranty[] = [];
const warrantyMap = new Map<number, string>()
let loading = false;

function wait(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const getWarrantyCacheList = async (authToken: string): Promise<IWarranty[]> => {

  if (warrantyList.length == 0 && !loading) {
    loading = true;
    const response = await API.get(authToken, 'api/v1/warranty')
      .catch((err) => {
        if (err.status === 404) {
          Alert(AlertTypes.ERROR, 'Warranties Not Found');
          return;
        }
        Alert(AlertTypes.ERROR, 'Warrantys: ' + err.message);
      });
    const wList = response.data as IWarranty[];
    warrantyList.push(...wList);
    loading = false;
  } else if (loading) {
    await wait(500);
    return getWarrantyCacheList(authToken);
  }
  return warrantyList;
}

export const getWarrantyCacheMap = async (authToken: string): Promise<Map<number, string>> => {
  if (!warrantyMap.size) {
    const wList = await (getWarrantyCacheList(authToken));
    wList.map(c => warrantyMap.set(c.warrantyId, c.name));
  }
  return warrantyMap;
}
